module.exports = __webpack_public_path__ + "static/media/icon_attente_big_gris.3654c2b7.svg";